// FlexBox > FlexBox
import React from 'react'
import styled from 'styled-components'
import { FlexBoxProps } from './index'

const FlexBox: React.SFC<Partial<FlexBoxProps>> = ({
	inline,
	container,
	direction,
	wrap,
	justify,
	alignItems,
	alignContent,
	grow,
	shrink,
	className,
	children,
	...rest
}) => {
	return (
		<div className={className} {...rest}>
			{children}
		</div>
	)
}

FlexBox.defaultProps = {
	inline: false,
	container: false,
	direction: 'row',
	wrap: 'nowrap',
	justify: 'flex-start',
	alignItems: 'stretch',
	alignContent: 'stretch',
	grow: 0,
	shrink: 1
}

export default styled(FlexBox)`
	${({ container, inline }) =>
		container ? (inline ? 'display: inline-flex;' : 'display: flex;') : ''} flex-direction: ${({ direction }) =>
			direction};
	flex-wrap: ${({ wrap }) => wrap};
	justify-content: ${({ justify }) => justify};
	align-items: ${({ alignItems }) => alignItems};
	align-content: ${({ alignContent }) => alignContent};
	flex-grow: ${({ grow }) => grow};
	flex-shrink: ${({ shrink }) => shrink};
`
